import type { Ref } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import type { Event } from "@/api/bale.zod";

import { useDeleteEvent } from "@/api/bale";
import { Button } from "@/components/Button";
import { CardSubtitleHeader, CardTextContent } from "@/components/Card";
import { Dialog } from "@/components/Dialog";

export function DeleteEventModal({
  ref,
  event,
  onClose,
}: {
  ref: Ref<HTMLDialogElement>;
  event: Event;
  onClose?: () => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deleteEvent = useDeleteEvent({ mutation: { onSuccess: () => navigate("/overview") } });

  return (
    <Dialog ref={ref} onClose={onClose} closeOnOutside className="flex max-h-200 w-lg flex-col">
      <CardSubtitleHeader>{t("delete-event-title")}</CardSubtitleHeader>
      <CardTextContent className="flex flex-col gap-4">
        <p>{t("delete-event-warning", { name: event.name || t("untitled-event") })}</p>
        <Button type="button" attention="danger" onClick={() => deleteEvent.mutate({ eventId: event.id })}>
          {t("delete-event-action")}
        </Button>
      </CardTextContent>
    </Dialog>
  );
}
